import { Calendar, Clock, Megaphone, X } from 'lucide-react';
import { Button, Card, Chip } from '@heroui/react';
import type { BulkSpotRequest } from '../../../api/my-parking-spots';
import { UsageTypeChip } from '../../../components/ui/usage-chips';
import { formatUsageDate, formatUsagePeriod } from '../../my-parking-spots/utils/usage-display';

interface BulkRequestCardProps {
  request: BulkSpotRequest;
  onCancel?: () => void;
}

export function BulkRequestCard({ request, onCancel }: BulkRequestCardProps) {
  const isExpired = request.expired;

  return (
    <Card className={isExpired ? 'opacity-80' : undefined}>
      <Card.Content className="flex flex-col gap-3 p-4">
        <div className="flex flex-wrap items-center gap-2">
          <Megaphone size={16} className="text-accent" />
          <span className="font-semibold">Solicitação em massa</span>
          <Chip size="sm" variant="soft" color={isExpired ? 'danger' : 'accent'}>
            {isExpired ? 'Expirada' : 'Ativa'}
          </Chip>
          <UsageTypeChip type={request.type} />
        </div>

        <p className="flex items-center gap-1.5 text-sm text-muted">
          <Calendar size={14} className="shrink-0" />
          <span>
            {formatUsagePeriod(request.startAt, request.endAt)}
          </span>
        </p>

        <p className="flex items-center gap-1.5 text-xs text-muted">
          <Clock size={12} className="shrink-0" />
          Criada em {formatUsageDate(request.createdAt)}
        </p>

        {!isExpired && onCancel ? (
          <Button size="sm" variant="danger" className="w-full sm:w-auto" onPress={onCancel}>
            <X size={14} />
            Cancelar solicitação
          </Button>
        ) : null}
      </Card.Content>
    </Card>
  );
}
